import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Button, Container, Row, Col, Media } from "reactstrap";
import { Link, Route } from "react-router-dom";
import AllSpecifications from "./../AllSpecifications/AllSpecifications";
import Search from "./../Search/Search";
import { clearDataAndSearch, setTerm } from "../actions/searchActions";
import { joinCss } from "../helpers/utils";
import HomeSearchAutoComplete from "./HomeSearchAutoComplete";

import appClasses from "../App.module.scss";
import classes from "./SearchField.module.scss";

import searchImg from "../images/searchHome.png";
import goToTriangle from "../images/goToTriangle.png";

class SearchField extends Component {
  constructor() {
    super();
    this.state = {
      xsSize: false
    };
  }

  goToSearch() {
    this.props.history.push("/Search/");
  }

  onKeyPressed(event) {
    if (event.charCode === 13) {
      //enter was pressed
      event.preventDefault();
      this.props.searchHandler();
      this.goToSearch();
    }
  }

  updateDimensions() {
    if (window.innerWidth <= 576 || window.screen.width <= 576) {
      this.setState({ xsSize: true });
    } else {
      this.setState({ xsSize: false });
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {
    return (
      <Container className={classes.HomeSearchDiv}>
        <Row>
          <Col className={classes.header}>חיפוש באתר</Col>
        </Row>
        <Row>
          <Col className={classes.searchCol}>
            <Form
              className={joinCss(classes.searchForm)}
              onKeyPress={e => this.onKeyPressed(e)}
            >
              <Row form>
                <Col
                  sm="12"
                  className={joinCss(classes.searchFieldCol, "pr-1")}
                >
                  {/* <Input
                    className={classes.searchInput}
                    type="search"
                    name="term"
                    id="term"
                    placeholder="הקלד מס'/שם פרק/שנה/חודש/דף תיקון/נושא לחיפוש"
                    onChange={e => this.props.termChangeHandler(e.target.value)}
                    //value={this.state.searchTerm}
                  /> */}
                  <HomeSearchAutoComplete />
                  <Button
                    link
                    className={classes.searchButton}
                    onClick={() => {
                      this.props.searchHandler();
                      this.goToSearch();
                    }}
                  >
                    <Media
                      src={searchImg}
                      alt="חפש"
                      className={classes.searchImg}
                    />
                  </Button>
                </Col>
              </Row>
            </Form>
            <Route path="/Search" exact component={Search} />
          </Col>
        </Row>
        <Row>
          <Col className={classes.searchLink}>
            <Link to={{ pathname: "/AllSpecifications" }}>
              או, עבור לכל הפרקים
              <Media
                src={goToTriangle}
                alt="חיפוש"
                className={appClasses.goToTriangle}
              />
            </Link>
            <Route
              path="/AllSpecifications"
              exact
              component={AllSpecifications}
            />
          </Col>
        </Row>
        {!this.state.xsSize ? (
          <div>
            <Row>
              <Col className={joinCss(classes.header, classes.aboutHeader)}>
                אודות
              </Col>
            </Row>
            <Row>
              <Col className={classes.subHeader}>
                המפרט הכללי לעבודות הבנייה ("הספר הכחול") הנו חלק ממסמכי המכרז
                והחוזה לבנייה של כל משרדי הממשלה (חוזה מדף 3210). כל פרקי המפרט
                הכללי העדכניים ניתנים להורדה, ללא תשלום.
              </Col>
            </Row>
          </div>
        ) : (
          ""
        )}
      </Container>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    searchHandler: () => {
      dispatch(clearDataAndSearch());
    },
    termChangeHandler: value => dispatch(setTerm(value))
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(SearchField)
);
